import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=02b4f6ca&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b4f6ca')) {
      api.createRecord('02b4f6ca', component.options)
    } else {
      api.reload('02b4f6ca', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=02b4f6ca&", function () {
      api.rerender('02b4f6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R6z7Pyy3zMgI/JS/comp/FavElement.vue"
export default component.exports